import {useApolloClient} from "@apollo/client";
import log from "loglevel";
import {useCallback} from "react";
import {JobFilter, JobSortInput, SearchableSortDirection} from "../generated/graphql";
import {buildJobQuery} from "../utils/dynamic-query/job-query-builder";

const jobSort: JobSortInput[] = [{field: "jobNumber", direction: SearchableSortDirection.Asc}];

export const useGetJob = (fields?: string[]) => {
  const apolloClient = useApolloClient();

  const getJob = useCallback(
    async (jobNumber: string) => {
      const jobFilter: JobFilter = {job: {jobNumber: {match: jobNumber}}};
      log.debug(jobNumber);
      const res = await apolloClient.query({
        query: buildJobQuery(fields),
        variables: {
          offset: 0,
          limit: 100,
          filter: jobFilter,
          sort: jobSort
        }
      });
      return res;
    },
    [apolloClient, fields]
  );

  return {getJob};
};
